/* eslint-disable security/detect-object-injection */
import * as React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

import { camelToTitle } from '@/helper/utility';

interface Properties {
  name: string;
  displayName?: string;
  size?: string;
  value?: string;
  money?: boolean;
  perHour?: boolean;
  percentage?: boolean;
  days?: boolean;
  negative?: boolean;
}

export function InputNumberDummy({
  name,
  displayName,
  size = 'col-12',
  value,
  money = false,
  perHour = false,
  percentage = false,
  days = false,
  negative = false
}: Properties) {
  displayName = displayName || camelToTitle(name);

  return (
    <Form.Group className={`mt-3 ${size}`}>
      <InputGroup hasValidation>
        <InputGroup.Text>{displayName}</InputGroup.Text>
        {money && <InputGroup.Text>&#36;</InputGroup.Text>}
        <Form.Control
          aria-label={name}
          name={name}
          id={name}
          type='number'
          disabled={true}
          min={negative ? '-99_999_999.99' : '0'}
          max='99_999_999.99'
          value={value}
        />
        {perHour && <InputGroup.Text>Per Hour</InputGroup.Text>}
        {percentage && <InputGroup.Text>&#37;</InputGroup.Text>}
        {days && <InputGroup.Text>Days</InputGroup.Text>}
      </InputGroup>
    </Form.Group>
  );
}
